import { Button, Tag as TagComponent, TagGroup, Text } from "@fluentui/react-components";
import CloseIcon from "~icons/material-symbols/close";
import { Tag } from "../../../models/tag";
import { useSelectedTagsListStyles } from "../styles/SelectedTagsList.styles";

type SelectedTagsListProps = {
  selectedTags: Tag[];
  removeItem: (tagId: string) => void;
  firstTagRef?: React.RefObject<HTMLButtonElement>;
};

export const SelectedTagsList = ({ selectedTags, removeItem, firstTagRef }: SelectedTagsListProps) => {
  const styles = useSelectedTagsListStyles();

  return (
    <div className={styles.selectedTagsList}>
      <TagGroup className={styles.tagsGroup} aria-label="TagGroup with dismissible Tags">
        {selectedTags.map((tag, index) => {
          return (
            <TagComponent key={tag.tagId} value={tag.tagId} ref={index === 0 ? firstTagRef : null}>
              <Text wrap={false} className={styles.tagText}>
                {tag.name}
              </Text>
              <Button appearance="subtle" size="small" icon={<CloseIcon />} onClick={() => removeItem(tag.tagId)} />
            </TagComponent>
          );
        })}
      </TagGroup>
    </div>
  );
};
